import request from '@/utils/http.js'

export function addLeader(data) {
    return request({
        url: '/leader/admin/add',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function getLeaderList(data) {
    return request({
        url: '/leader/list',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function updateLeader(data) {
    return request({
        url: '/leader/admin/update',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function delLeader(data) {
    return request({
        url: '/leader/admin/del',
        headers: {
            isToken: true
        },
        method: 'delete',
        data:data
    })
}
